import { LoggerFactory } from '@ibe/services';
import React, { useEffect, useState, JSX } from 'react';
import { FormGroup } from 'reactstrap';
import fallback from '../../../../_Translations/generated/filter-option.en.t.json';
import Keys from '../../../../_Translations/generated/filter-option.en.t.json.keys';
import useTranslation from '../../../Hooks/useTranslation';
import CustomInput from '../../CustomInput/CustomInput';

const logger = LoggerFactory.get('FilterOption.tsx');

export interface Props {
  id: string; // you have to create a key anyway, so just pass something similar along
  label: string;
  resultsCount?: number;
  showResultsCountInParenthesis?: boolean;
  showResultsCount?: boolean;
  showEmptyOptionsWhenFiltering?: boolean;
  isActive?: boolean;
  onChange?: (isActive: boolean) => void;
}

const FilterOption = (props: Props): JSX.Element => {
  const { t } = useTranslation('filter-option', fallback, Keys);
  const {
    label,
    id,
    onChange,
    isActive,
    resultsCount,
    showResultsCountInParenthesis,
    showResultsCount,
    showEmptyOptionsWhenFiltering
  } = props;
  const change = onChange || null;

  const [active, setIsActive] = useState<boolean>(isActive || false);

  useEffect((): void => setIsActive(isActive || false), [isActive]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const target = e.target as HTMLInputElement;
    const checked = target.checked || false;
    setIsActive(checked);
    if (change) {
      change(checked);
    } else {
      logger.log(`${id}.checked`, checked);
    }
  };

  const format = (str: string): string => {
    if (str.includes(';')) {
      const parts = str.split(';');
      let result = '';
      parts.forEach((element: string): void => {
        result = `${result} ${t(element, element)}`;
      });
      return result;
    }
    return t(str, str);
  };

  return (
    <>
      {(resultsCount !== 0 || showEmptyOptionsWhenFiltering) && (
        <FormGroup check className="p-0 iso__baseLayoutFilter__formGroup">
          <CustomInput
            type="checkbox"
            id={id}
            name={id}
            checked={active}
            onChange={handleChange}
            className="d-inline"
            aria-label={format(label)}
            label={
              <div>
                <span>{format(label)}</span>
                {showResultsCount && Number.isInteger(resultsCount) && (
                  <span
                    className={
                      showResultsCountInParenthesis ? '' : 'iso__baseLayoutFilter__filterCount'
                    }
                  >
                    {showResultsCountInParenthesis ? ` (${resultsCount})` : ` ${resultsCount}`}
                  </span>
                )}
              </div>
            }
          />
        </FormGroup>
      )}
    </>
  );
};

export default FilterOption;
